import { useSliderContext } from '@cian/slider';
import { RoundButton } from '@cian/ui-kit';
import { IconActionChevronLeft16, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import { FC } from 'react';

import styles from './SliderButtons.css';

export const SliderButtons: FC = () => {
  const { scrollPrev, scrollNext } = useSliderContext();

  return (
    <div className={styles['container']}>
      <RoundButton onClick={scrollPrev} theme="fill_light" title="Назад" icon={<IconActionChevronLeft16 />} />
      <RoundButton onClick={scrollNext} theme="fill_light" title="Вперёд" icon={<IconActionChevronRight16 />} />
    </div>
  );
};
